// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"166":"87cc5996","430":"9f4bc4c1","828":"1a3ef556","945":"b03d3a10"}[chunkId] + ".chunk.js";
};